// common
import {
  VuexModule,
  Module,
  Mutation,
  getModule,
  Action,
} from "vuex-module-decorators";
import store from "@/store";

// interfaces
import { IModalState } from "@/interfaces/store/IModal";

// constants
import { ModalProps, ModalStatus } from "@/constants/modal";

@Module({ dynamic: true, namespaced: true, store, name: "Modal" })
class Modal extends VuexModule implements IModalState {
  public status = ModalStatus.Hidden;
  // Indicates whether a user shall logout after a modal is closed
  public shallLogout = false;
  // pass props to modals
  public modalProps: ModalProps = {};

  @Mutation
  public setStatus(status: ModalStatus) {
    this.status = status;
  }

  @Mutation
  public setShallLogout(shallLogout: boolean) {
    this.shallLogout = shallLogout;
  }

  @Mutation
  public setModalProps(modalProps: ModalProps) {
    this.modalProps = modalProps;
  }

  /**
   * Invoked to close or when closing the Modal
   */
  @Action
  public close() {
    this.setStatus(ModalStatus.Hidden);
  }
}

const ModalModule = getModule(Modal);
export default ModalModule;
